import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../AppContext';

const MulticityRouteInfo = ({ itineraryInfo }) => {
  const { trackTemplateEvent } = useContext(Context);

  const initializeCollapseStateMap = initVal => {
    const stateMap = new Map<number, boolean>();
    itineraryInfo.forEach((_, idx) => {
      stateMap.set(idx, initVal);
    });
    return stateMap;
  };

  const [cabInfoState, setCabInfoState] = useState<Map<number, boolean>>(
    initializeCollapseStateMap(false)
  );

  useEffect(() => {
    setCabInfoState(initializeCollapseStateMap(true));
  }, []);

  const updateCollapseState = (idx, val) => {
    const newCabInfoState = new Map(cabInfoState);
    newCabInfoState.set(idx, val);
    setCabInfoState(newCabInfoState);
  };

  return (
    <>
      <div className="Itinerary leftRightPadding">
        <h2 className="ItineraryTitle">
          Detailed Itinerary for your selected route
        </h2>
        {itineraryInfo.map(({ route, distance, duration, details }, idx) => (
          <div
            onClick={() => {
              trackTemplateEvent(`Itinerary_Click_${route}`);
              updateCollapseState(idx, !cabInfoState.get(idx));
            }}
            className="ItineraryInfo"
          >
            <div>
              <div className="makeFlex">
                <div className="itineraryDay makeFlex perfectCenter">
                  <div className="textCenter">
                    <div>{`Day`}</div>
                    <div className="itineraryDayText">{`${idx + 1}`}</div>
                  </div>
                </div>
                <div>
                  <div className="itineraryRoute">{route}</div>
                  <div className="makeFlex">
                    <div className="itineraryDistance">{distance} kms </div>
                    <div className="itineraryDuration">{duration}</div>
                  </div>
                </div>
              </div>
              {!cabInfoState.get(idx) ? (
                <div className="itineraryDetails">{details}</div>
              ) : null}
            </div>
            <div
              style={{ marginLeft: 'auto', marginRight: '10px' }}
              className={`vertlCenter detailsButton arrow vertlCenter ${
                !cabInfoState.get(idx) ? 'up' : 'down'
              }`}
            ></div>
          </div>
        ))}
      </div>
    </>
  );
};

export default MulticityRouteInfo;
